import numbro from "numbro";

// switch between locales
numbro.registerLanguage(require("numbro/languages/de-DE")); // tslint:disable-line
numbro.setLanguage("de-DE");

export function currencyVal(val: number) {
  return numbro(val).format({
    thousandSeparated: true,
    mantissa: 2
  });
}

export function parseLocaleDecimal(value: string) {
  return numbro.unformat(value);
}



// WEBPACK FOOTER //
// ./src/app/helper.ts